import { formatNumber, unformat as unformatInternal } from "./accounting";
export function formatNumber2(value, precision, minPrecision = precision, thousand = ",", decimal = ".") {
    return formatNumber(value, {
        minPrecision,
        precision,
        thousand,
        decimal
    });
}
export function unformat(value) {
    if (!value)
        return undefined;
    const floatValue = unformatInternal(value);
    if (isNaN(floatValue))
        return undefined;
    return floatValue;
}
export const round = (d, decimals = 2) => {
    const m = Math.pow(10, decimals);
    return Math.round(d * m) / m;
};
